import Api from '@/api/Api';

class CharityPositionsApi extends Api {
  constructor() {
    super('charities/positions', 'charitiespositions');
  }
}
const charityPositionsApi = new CharityPositionsApi();
export default charityPositionsApi;
